<template>
    <div
        class="bg-gray-900 shadow-md rounded-md flex sm:flex-row flex-col items-center justify-between p-3 border-b-4 border-red-700 text-white group"
    >
        <div class="flex justify-center items-center md:w-14 md:h-14 w-10 h-10 bg-white rounded-full transition-all duration-300 transform group-hover:rotate-12 group-hover:scale-105">
            <SvgIcon
                :name="icon"
                class="stroke-current text-gray-800 transition transform duration-300"
            />
        </div>
        <div class="sm:text-right text-center sm:mt-0 mt-3">
            <p class="text-2xl">{{ content }}</p>
            <p>{{ title }}</p>
        </div>
    </div>
</template>

<script>
import SvgIcon from 'UI/SvgIcon';
export default {
    props: ['icon', 'title', 'content'],
    components: {
        SvgIcon
    }
}
</script>

<style>

</style>
